import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export function FlowNodeFields({ localNodeData, updateNodeData, flowList }) {
  return (
    <Box sx={{ mt: 2 }}>
      <FormControl fullWidth>
        <InputLabel id="flow-select-label">Cambio de Flujo</InputLabel>
        <Select
          labelId="flow-select-label"
          value={localNodeData.flowChange || ''}
          label="Cambio a Flujo"
          onChange={(e) => updateNodeData('flowChange', e.target.value)}
        >
          {flowList.map((flow) => (
            <MenuItem key={flow.id} value={flow.id}>
              {flow.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}